import React from 'react';
import { Card } from 'element-react';
import { useTranslation } from 'react-i18next';
//import PlaceholderImageSVG from '../components/PlaceholderImageSVG';
//import PlaceholderImageSVG from '../assets/imgs/bainub-product-placeholder.svg';
import PlaceholderImageSVG from '../assets/imgs/PlaceholderImgProduct.svg';
// Este componente ahora representa la tarjeta de "producto vacío"
const PlaceholderProductBox = () => {
    const { t } = useTranslation();

    return (
        <Card className="product-box placeholder-card"> {/* Agregamos 'placeholder-card' para estilos */}
            <div className="placeholder-image-wrapper">
                {/* Usa el componente SVG importado */}
                <img src={PlaceholderImageSVG} alt="Product placeholder" />
            </div>
            <div className="placeholder-content">
                <div className="placeholder-text product-name">{t('placeholder.name', 'Product Name')}</div>
                <div className="placeholder-text company-name">{t('placeholder.company', 'By: Your Company')}</div>
                <div className="placeholder-text price-range">{t('placeholder.price_range', 'Price Range: $-- to $--')}</div>
            </div>
        </Card>
    );
}

export default PlaceholderProductBox;